module.exports = __webpack_public_path__ + "img/91.36494a03.jpg";